/**
 * The IANA timezone a clinic without a `timezone` field is read in. The one
 * definition — frontend and functions both import it (docs/standards/dates.md
 * rule 2).
 */
export const DEFAULT_TIMEZONE = "America/New_York";
